export default "__VITE_ASSET__CX1INCU3__"